import React from "react";
import "../styles.css";
import Menu from "./Menu";
import {FaFacebookF} from 'react-icons/fa';
import {FaFacebookMessenger} from 'react-icons/fa';
import {FaInstagram} from 'react-icons/fa';
import {FaHands} from 'react-icons/fa';

const Base = ({
	title = "",
	description = "",
	className = "text-white p-4 jumbo",
	children
}) => (
		<div>
			<Menu />
			<div className="container-fluid main-base">
				<div className="jumbotron jumbo text-dark text-center">
					<b><h2 className="display-4 text_style">{title}</h2></b>
					<p className="lead">{description}</p>
				</div>
				<div className={className}>{children}</div>
			</div>
			<footer className="footer py-3">
				<div className="container-fluid contact-bg text-dark text-center py-3">
				<h4>Contact us from here!</h4>
				<a target="_blank" href="https://www.facebook.com/sgcmsg">
                    <FaFacebookF className="Fb" target="_blank" style={{height: 30, width:30, margin:5}}/>
					</a>
                    <a target="_blank" href="https://www.m.me/sgcmsg">
                    <FaFacebookMessenger className="Msngr" target="_blank" style={{height: 30, width:30, margin:25}}/>
					</a>
                    <a className="btn btn-primary btn-lg" target="_blank" href="https://www.m.me/sgcmsg">Contact Us</a>
                    <a target="_blank" href="https://instagram.com/sastogiftcards">
                    <FaInstagram className="Insta" target="_blank" style={{height: 30, width:30, margin:25}}/>
					</a>
                    <a target="_blank" href="https://facebook.com/groups/sastogiftcards">
                    <FaHands className="Fbgroup" target="_blank" style={{height: 30, width:30, margin:5}}/>
					</a>
				</div>
				<div className="container">
					<div className="text-muted text-center">
						&copy; 2020 <span className="text-dark">Sasto Gift Cards</span> All right reserved
                    </div>
				</div>
			</footer>
		</div>
	);

export default Base;
